import { MAILVISTA_URLS } from "@cs_teamwaydev/mailvista-sdk_react";
import MailvistaUrls from "../enums/MailvistaUrls";

export default class MailvistaUrl {
    id: MailvistaUrls;

    url: string;

    title: string;

    constructor(id: MailvistaUrls, url: string, title: string) {
        this.id = id;
        this.url = url;
        this.title = title;
    }
}

export const MAILVISTA_DOMAIN_URLS = MAILVISTA_URLS;
